export default {
  fr: {
    languages: {
      language: 'La langue',
      english: 'English',
      french: 'Français'
    },
    login: {
      email: 'Email',
      emailPlaceholder: 'Entrer Email',
      password: 'Mot de passe',
      passwordPlaceholder: 'Entrer mot de passe',
      login: 'Se connecter à'
    },
    nav: {
      dashboard: 'Tableau de Bord',
      media: 'Médias',
      chargers: 'Chargeurs',
      partners: 'Programmes Partenaires',
      sky: 'Objets SKY',
      users: 'Utilisateurs',
      reports: 'Rapports',
      logout: 'Déconnecter'
    },
    labels: {
      search: 'Chercher',
      selectOne: 'choisir un',
      selectOption: 'Sélectionnez une option',
      cost: 'Coût',
      optional: 'optionnel',
      seconds: 'secondes'
    },
    buttons: {
      uploadMedia: 'Télécharger un Média',
      viewMedia: 'Voir le Média',
      editMedia: 'Editer Média',
      createReports: 'Créer des Rapports',
      createMore: 'Créer Plus',
      view: 'Voir',
      grid: 'Grille',
      table: 'Tableau',
      resume: 'Reprendre',
      edit: 'Editer',
      save: 'Sauvegarder',
      savePublish: 'Enregistrer & Publier',
      republish: 'Republier',
      delete: 'Effacer',
      cancel: 'Annuler',
      done: 'Terminé',
      back: 'Retour',
      continue: 'Continuer',
      skipForNow: 'Ignorez pour l\'instant',
      skipSaveDraft: 'Passer & enregistrer comme brouillon',
      finalReview: 'Examen Final',
      saveUpload: 'Enregistrer & Télécharger',
      close: 'Fermer',
      revisit: 'Revisiter',
      uploadMore: 'Télécharger Plus',
      noGoBack: 'Non, reviens',
      yesDelete: 'Oui, supprimer',
    },
    dashboard: {
      liveMedia: 'Médias en Direct',
      expiringSoon: 'Expire Bientôt',
      goingLiveSoon: 'En Direct Bientôt',
      incomplete: 'Incomplet'
    },
    media: {
      sortBy: 'Trier par',
      name: 'Nom',
      status: 'Statut',
      goLiveDate: 'Aller Live Date',
      expirationDate: 'Date d\'expiration',
      expirationDateAbbr: 'Date d\'exp.',
      createdOn: 'Créé sur',
      createdBy: 'Créé par',
      uploadTo: 'Télécharger sur',
      chargers: 'Chargeurs',
      stations: 'Stations',
      states: 'États',
      zipCodes: 'Codes Postal',
      duration: 'Durée',
      cost: 'Coût',
      comments: 'Commentaires',
      preview: 'Aperçu',
      screen: 'Écran',
      screensaver: 'Économiseur d\'écran',
      presentPayment: 'Paiement Actuel',
      payment: 'Paiement',
      thankYou: 'Merci',
      audience: 'Public',
      utility: 'Utilitaire',
      deleteModal: 'Êtes-vous sûr de bien vouloir supprimer cet élément?',
      warningModal: 'La modification de ce contenu rétablira INCOMPLETE et ne sera plus défini sur LIVE. Vous devez terminer le processus de révision et cliquer sur "Enregistrer et republier" pour vous assurer qu\'il est redéfini sur LIVE. Êtes-vous sûr de vouloir continuer?'
    },
    status: {
      incomplete: 'Incomplet',
      inQueue: 'Dans la Queue',
      live: 'En Direct',
      archived: 'Archivé'
    },
    charger: {
      screenID: 'ID d\'Écran',
      city: 'Ville',
      screensInUse: 'Écrans en cours d\'utilisation'
    },
    users: {
      firstName: 'Prénom',
      lastName: 'Nom de Famille',
      role: 'Rôle',
      pending: 'En Attendant',
      assignRole: 'Attribuer un Rôle',
      editRole: 'Modifier le Rôle',
      admin: 'Admin',
      editor: 'Éditeur',
      viewer: 'Voir Seulement'
    },
    reports: {
      title: 'Sélectionnez les rapports à créer',
      subtitle: 'Un rapport distinct sera généré pour chaque option sélectionnée.',
      allMedia: 'Tous les Médias',
      liveMedia: 'Médias en Direct',
      archivedMedia: 'Médias Archivés',
      incompleteMedia: 'Média Incomplet',
      mediaByScreen: 'Média par Écran',
      mediaByPriority: 'Média par Priorité',
      mediaByPartnerProgram: 'Programme Media by Partner',
      mediaByChannel: 'Média par Canal (IHM, Portail, ou Application Mobile)',
      mediaByID: 'Média par ID de Station, ID de Chargeur, ou Jôte de Site/Entreprise',
      allChargers: 'Tous les Chargeurs',

      doneTitle: 'Rapport créé avec succès! | Rapports créés avec succès!',
      doneSubtitle: 'Il devrait télécharger automatiquement en tant que CSV. Si non, vous pouvez | Ils devraient télécharger automatiquement au format ZIP. Si non, vous pouvez',
      doneDownloadAgain: 'le télécharger à nouveau | les télécharger à nouveau'
    },
    create: {
      platformTitle: 'Sur quelle plate-forme importez-vous des médias?',
      platformSubtitle: 'Téléchargez-vous de nouveaux supports par défaut pour les chargeurs?',
      platformDefaultLink: 'Si oui, cliquez ici',
      platformPortal: 'Portail',
      platformMobileApp: 'Application mobile',
      titleHMI: 'Transférer vers HMI selon',
      nameTitle: 'Nommez ces médias',
      nameSubtitle: 'Les noms sont uniquement pour ce système et n\'apparaîtront pas sur les écrans du chargeur.',
      namePlaceholder: 'Tapez le nom ici...',
      datesTitle: 'Fixer les dates de mise en ligne et d\'expiration',
      datesSubtitle: 'À San Francisco, si vous planifiez l\'activation des ressources le lundi, celles-ci le seront à midi, heure du Pacifique.',
      datesGoLive: 'Aller Vivre',
      datesExpire: 'Expirer',
      datesExpireOptions: 'Après {n} jours',
      datesExpireSpecific: 'Une date précise...',
      datesExpireNever: 'Jamais',
      detailsTitle: 'Entrez des détails supplémentaires et téléchargez le média',
      detailsSubtitle: 'Types de fichiers autorisés',
      detailsForgotCategory: 'Oublié une catégorie?',
      detailsForgotAddMore: 'Retourner et ajouter plus',
      detailsCommentsPlaceholder: 'Cela n\'apparaîtra pas sur les chargeurs...',
      uploadChooseFile: 'Choisir le fichier',
      uploadOnScreenPreview: 'Aperçu à l\'écran (cliquez pour agrandir)',
      uploadCroppedSmall: 'L\'image recadrée est trop petite et sera étirée.',
      uploadStandard: 'Standard',
      uploadWidescreen: 'Écran Large',
      reviewTitle: 'Donner à tous un dernier regard',
      reviewSubtitle: 'Tous les éléments surlignés en rouge doivent être corrigés pour que les supports puissent être ajoutés à la file d\'attente de go-live.',
      reviewUploadingTo: 'Envoi vers',
      reviewNoTag: 'aucun tag | pas de tags',
      reviewNoName: 'sans nom',
      reviewNoGoLive: 'pas de date de mise en ligne',
      reviewNoExpire: 'pas de date d\'expiration',
      reviewNoMedia: 'aucun média téléchargé',
      doneTitleDefault: 'Le média par défaut a été téléchargé avec succès!',
      doneTitle: 'Médias mis en ligne avec succès!',
      defaultTitle: 'Téléchargez le média par défaut pour:',
      defaultTitleCountry: 'Téléchargez le média par défaut',
      defaultSubtitleUSA: 'Ces images apparaîtront sur TOUS LES CHARGEURS AU USA lorsqu\'aucune autre image n\'est attribuée.',
      defaultSubtitleCanada: 'Ces images apparaîtront sur TOUS LES CHARGEURS AU CANADA lorsqu\'aucune autre image n\'est attribuée.',
      hmiLocationTitle: 'Emplacement',
      hmiPartnerTitle: 'Partenaire',
    },
    tags: {
      sitehost: 'Entreprise',
      partners: 'Programmes Partenaires',
      state: 'Etat/Province',
      zip: 'ZIP/Code Postal',
      stationId: 'Emplacement',
      chargerId: 'ID de la Station'
    }
  }
}